<template>
  <el-tooltip 
    placement="bottom"
  >
    <div slot="content">
      <slot></slot>
    </div>
    <i :class="type + ' helper-icon ml-default el-icon-info'" :style="size" />
  </el-tooltip>
</template>
<script>
export default {
  name: 'AHelper',
  props: {
    type: {
      type: String,
      default: 'danger'
    },
    size: {
      type: String,
      default: ""
    }
  }
}
</script>